import type { AuthResponse, InvitationPreview } from '../types';
import { http } from '@/shared/api/httpClient';

export const authApi = {
  login: (email: string, password: string) => http.post<AuthResponse>('/auth/login', { email, password }).then((r) => r.data),
  logout: () => http.post('/auth/logout').then(() => undefined),
  forgot: (email: string) => http.post('/auth/password/forgot', { email }).then(() => undefined),
  reset: (token: string, password: string) => http.post('/auth/password/reset', { token, password }).then(() => undefined),
  invitation: (token: string) => http.get<InvitationPreview>(`/auth/invitations/${encodeURIComponent(token)}`).then((r) => r.data),
  /** Sets (or with null removes) the signed-in user's picture; returns the refreshed session user. */
  setAvatar: (avatarUrl: string | null) => http.put<Pick<AuthResponse, 'user'>>('/me/avatar', { avatarUrl }).then((r) => r.data.user),
  acceptInvitation: (token: string, displayName: string, password: string) =>
    http.post<AuthResponse>(`/auth/invitations/${encodeURIComponent(token)}/accept`, { displayName, password }).then((r) => r.data)
};
